import React from 'react'

import type { IconProps } from './types'

const Activities: React.FC<IconProps> = ({
  size = 24,
  color = '#2D87F3',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M19.008 12.313a.76.76 0 0 1-.558-.225.76.76 0 0 1-.225-.558q0-.333.225-.558a.76.76 0 0 1 .558-.225h2.209q.333 0 .558.225t.225.558a.76.76 0 0 1-.225.558.76.76 0 0 1-.558.225zm-.215 6.562-1.76-1.323a.74.74 0 0 1-.318-.513.8.8 0 0 1 .159-.587.74.74 0 0 1 .513-.318.8.8 0 0 1 .587.16l1.76 1.322a.74.74 0 0 1 .318.513.8.8 0 0 1-.158.588.74.74 0 0 1-.513.317.8.8 0 0 1-.588-.159m-.86-12.148a.8.8 0 0 1-.587.158.74.74 0 0 1-.513-.317.8.8 0 0 1-.158-.587.74.74 0 0 1 .317-.513l1.761-1.324a.8.8 0 0 1 .587-.158.74.74 0 0 1 .513.317q.201.276.159.587a.74.74 0 0 1-.317.513zm-12.98 11.57v-4.076H3.888q-.781 0-1.335-.553A1.82 1.82 0 0 1 2 12.333v-1.606q0-.78.553-1.335a1.82 1.82 0 0 1 1.335-.553h4.036l3.247-1.942a.88.88 0 0 1 .952-.005q.48.279.48.819v7.638q0 .54-.48.819a.88.88 0 0 1-.952-.005L7.924 14.22H6.518v4.076zm9.096-3.51V8.273q.615.555.99 1.402.376.845.376 1.855t-.376 1.855-.99 1.402"
        fill={color}
      />
    </svg>
  )
}

export default Activities
